import styles from './stacked-bar-chart.module.scss';
import { Chart } from 'react-chartjs-2';
import { ChartProps } from '../ChartWidget';
import { ChartData, ChartOptions } from 'chart.js';
import StackedBarLabelIcons from './stacked-bar-label-icons/StackedBarLabelIcons';
import clsx from 'clsx';

const colors = ['#88034F', '#49A295', '#D86118', '#0074C7', '#825574'];
const background = ['#EBEEF1'];

const StackedBarChart = ({ chartType, data, labels }: ChartProps) => {
  const dataPoints = data as number[][];

  const barData: ChartData = {
    labels: labels,
    datasets: dataPoints.map((value, index) => {
      return {
        data: value,
        backgroundColor: index === 0 ? colors : background,
        hoverBackgroundColor: index === 0 ? colors : background,
        barThickness: 32,
        borderRadius: 4,
        label: `data ${index + 1}`
      };
    })
  };

  const barOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    hover: {
      intersect: false,
      includeInvisible: false
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: false
      }
    },
    scales: {
      x: {
        display: false,
        stacked: true,
        grid: {
          display: false
        }
      },
      y: {
        display: false,
        stacked: true,
        grid: {
          display: false
        }
      }
    }
  };

  return (
    <>
      <div>
        <Chart
          id={'stackedBarChartCanvas'}
          className={clsx(styles.StackedBarChart)}
          type={chartType === 'bar' ? 'bar' : 'bar'}
          data={barData}
          options={barOptions}
          redraw
        />
      </div>
      <div style={{ marginRight: 10 }}>
        <StackedBarLabelIcons />
      </div>
    </>
  );
};

export default StackedBarChart;
